// @todo revisit once FF supports :has - now :D

const selects = [...document.querySelectorAll('form select')];
const textareas = [...document.querySelectorAll('textarea')];
const addMoreSelects = [...document.querySelectorAll('.form-item--add-more')];
const selectedClass = 'form-select--selected';

const updatePlaceholder = (input) => {
  if (input.options[input.selectedIndex].value !== '') {
    input.classList.add(selectedClass);
  } else {
    input.classList.remove(selectedClass);
  }
};

const moveTheLabel = (element) => {
  const wrapper = element.parentNode;
  if (wrapper.nextElementSibling) {
    wrapper.appendChild(wrapper.nextElementSibling);
  }
};

const hideAddMore = () => {
  // this could be solved with CSS with :has() :/
  addMoreSelects.forEach((checkbox) => {
    checkbox.querySelector('input').addEventListener('change', ({ target }) => {
      if (target.checked) {
        target.parentNode.style.display = 'none';
        target.checked = false;
      }
    });
  });
};

const updateSelects = () => {
  selects.forEach((select) => {
    moveTheLabel(select);

    select.addEventListener('change', ({ target }) => {
      updatePlaceholder(target);
      hideAddMore();
    });
  });
};

const updateTextareas = () => {
  textareas.forEach((textarea) => {
    moveTheLabel(textarea);
  });
};

(() => {
  if (selects.length) {
    updateSelects();
  }
  if (textareas.length) {
    updateTextareas();
  }
})();
